import * as React from 'react';
import {TypographyClassNames, Icon} from '@openfin/desktop-ui';

import * as InvalidSearchIcon from '../../../assets/InvalidSearch.svg';

import * as Styles from './SearchMessage.module.scss';

interface Props {
    icon: string;
    header: string;
    subheader: string;
}

export const SearchMessage: React.FC<Props> = (props) => {
    const {icon, header, subheader} = props;

    return (
        <div className={Styles['search-message']}>
            <div className={Styles['message']}>
                <Icon src={icon} className={Styles['icon']} />
                <h1 className={TypographyClassNames.Heading1}>{header}</h1>
                <p className={TypographyClassNames.Body}>{subheader}</p>
            </div>
            <div className={Styles['contact-us']}>
                <p className={TypographyClassNames.Caption}>Need Assistance?</p>
                <a href="mailto:support@openfin.co" className={TypographyClassNames.Button2}>Contact us</a>
            </div>
        </div>
    );
};

export const NoResults = () => <SearchMessage header="No Results Found" subheader="Please try another search" icon={InvalidSearchIcon} />;
export const SearchError: React.FC<{engine?: string}> = (props) => {
    const {engine = 'unknown'} = props;
    return <SearchMessage header={`Error Searching ${engine}`} subheader="Please try another search" icon={InvalidSearchIcon} />;
};
